import React from "react";
import { FormattedMessage } from "react-intl";
import useAccessibilityContext from "../accessibility/store/use-accessibility-context";
import useTranslate from "@default/hooks/use-translate";

const ThemeSwitch = () => {
  const { theme, toggleTheme } = useAccessibilityContext();
  const _t = useTranslate();

  return (
    <li className="contrast-toggle">
      <div className="col">
        <button
          onClick={toggleTheme}
          className="toggle contrast"
          id="contrast-toggle"
          data-active={theme === "dark"}
          aria-label={` ${_t("accessibility.contrast_mode")} ${_t(theme === "light" ? "enable" : "disable")}`}
        >
        <span className="sr-only">
          {` ${_t("accessibility.contrast_mode")} ${_t(theme === "light" ? "enable" : "disable")}`}
        </span>
        </button>
      </div>

      <div className="col">
        <span className="label">
          <FormattedMessage id={"accessibility.contrast"} />{" "}
        </span>
      </div>
    </li>
  );
};

export default ThemeSwitch;
